import { client, errorHandler } from "./api";

export async function AuthRequest(token, context) {
  const response = await client.get("auth-request", {
    headers: {
      "Authorizations": token,
    }
  }).catch(error => errorHandler(error, context, null));
  return {
    "token": response.data["token"],
    "user_role_id": response.data["user_role_id"],
    "expire": response.data["expire"]
  };
}

export async function initialRequest(context, token) {
  const response = await client.get("initial-data", {
    headers: {
      "Authorizations": token,
    }
  }).catch(error => errorHandler(error, context, null))
  if (response) {
    return response.data;
  }
}

export async function taskInitialRequest(context, token) {
  const response = await client.get("task-initial-data", {
    headers: {
      "Authorizations": token,
    }
  }).catch(error => errorHandler(error, context, null))
  if (response) {
    return response.data;
  }
}

export async function taskHandler(task_data, token, context, then) {
  const response = await client.post("task-handler", {
    ...task_data
  }, {
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, then))
  if (response) {
    return response.data;
  }
}

export async function taskClearAll(context, token) {
  const response = await client.post("task-ctear-all", {}, {
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, null))
  if (response) {
    return response.data;
  }
}

export async function sendCalculateRequest(registr_data, token, context, then) {
  const response = await client.post("calculate", {
    ...registr_data
  }, {
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, then))
  if (response) {
    return response.data;
  }
}

export async function sendXlsxRequest(registr_data, token, context, then) {
  const response = await client.post("calculate-xlsx", {
    ...registr_data
  }, {
    responseType: "blob",
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, then))
  if (response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "data.xlsx"); // Имя скачиваемого файла
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    // return response.data;
  }
}

export async function sendTrpForecastRequest(forecast_data, token, context, then) {
  const response = await client.post("trp-forecast", {
    ...forecast_data
  }, {
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, then))
  if (response) {
    return response.data;
  }
}

export async function getTrpVtr(duration, token, context) {
  const response = await client.get("trp-vtr", {
    params: { duration },
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, null))
  if (response) {
    return response.data;
  }
}

export async function getTrpReach(sex, booked_impressions, token, context) {
  const response = await client.get("trp-reach", {
    params: { sex, booked_impressions },
    paramsSerializer: {
      indexes: null
    },
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, null))
  if (response) {
    return response.data;
  }
}

export async function getTrpInitialData(token, context) {
  const response = await client.get("trp-initial-data", {
    headers: {
      "Authorizations": token
    }
  }).catch(error => errorHandler(error, context, null))
  if (response) {
    return response.data;
  }
}